import { isEmpty } from 'lodash-es'
import eventBus from '@/service/EventBus.js'
import { Capacitor } from '@capacitor/core'

let started = false
let currentVersion = null
const oneMinute = 1000 * 60

function start() {
    if (started ||
        process.env.KN_WS_ENDPOINT === 'http://localhost:3333'||
        Capacitor.isNativePlatform()) return
    started = true
    currentVersion = JSON.parse(process.env.KN_VERSION_JSON)
    eventBus.spa.emit('maintenance-mode', currentVersion['maintenanceMode'])
    setTimeout(checkNewVersion, 10)
    setInterval(checkNewVersion, oneMinute)
}

async function checkNewVersion() {
    const latestVersion = await fetchNewVersion()
    if (isEmpty(latestVersion)) return

    eventBus.spa.emit('maintenance-mode', latestVersion['maintenanceMode'])

    if (latestVersion.uiBuildTime > currentVersion.uiBuildTime) {
        eventBus.spa.emit('new-ui-version-detected')
    }
}

async function fetchNewVersion() {
    try {
        const response = await fetch(`https://${process.env.KN_ENV}.kinectin.com/version.json`)
        if (!response.ok) {
            console.error(`error fetching version data... status: ${response.status}`)
            return {}
        }
        return await response.json()
    } catch (error) {
        console.error('Error fetching version data:', error)
    }
}

export default {
    start,
}